<template>
  <div class="order-list">
    <b-row no-gutters>
      <b-col cols="12">
          <b-form-group
            id="order-form">

              <span class="orders-search">
                  <b-input-group>
                      <b-form-input
                      id="order-search-input"
                      placeholder="Order ID or Email"
                      v-model="customerId"
                      trim>
                        
                      </b-form-input>

                      <b-input-group-append>
                        <b-button class="search-button" variant="light"><b-icon icon="arrow-return-left" @click="orderSearch"/></b-button>
                      </b-input-group-append>

                      <b-input-group-append>
                          <b-dropdown id="tags-input" dropright no-caret>

                              <template #button-content>
                                <b-icon icon="tags"/>
                              </template>
                              <b-dropdown-form>
                                  <b-form-checkbox-group
                                    v-model="selectedFilterTags"
                                    :options="filterTagOptions"
                                    @change="orderSearch"
                                    switches
                                    stacked>
                                  </b-form-checkbox-group>
                              </b-dropdown-form>

                          </b-dropdown>
                      </b-input-group-append>
                  </b-input-group>
              </span>
          </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      
      <b-col cols="12">
        <b-overlay :show="loadingOrders" rounded="sm">
          <b-list-group id="orders" @scroll="onScroll">

              <b-list-group-item 
                class="order-row" 
                button v-for="o in orders" :key="o.id" :id="o.id"
                :active="selectedOrder.id === o.id"
                @click="selectOrder(o)">
                {{ o.name }}
                <div><span><b-badge v-for="tag in o.tags" class="mr-1">{{ tag }}</b-badge></h2></span></div>
              </b-list-group-item>

              <b-list-group-item v-if="paginatingOrders" class="order-row text-center">
                 <b-spinner label="Spinning"></b-spinner>
              </b-list-group-item>

              <b-list-group-item v-if="noMoreOrders" class="order-row text-center">
                 <span class="text-muted">No more orders</span>
              </b-list-group-item>
          </b-list-group>
         </b-overlay>
      </b-col>
     
    </b-row>
  </div>
</template>

<script>
export default {
  name: "OrderList",
  data() {
    return {
      customerId: "",
      loadingOrders: true,
      selectedOrder: {},
      paginatingOrders: false,
      filterTagOptions: [
        { text: "ready-to-ship", value: "ready-to-ship" },
        { text: "international", value: "international" },
        { text: "brad", value: "brad" },
        { text: "valerie", value: "valerie" },
        { text: "st1", value: "ST1" },
        { text: "st2", value: "ST2" },
        { text: "st3", value: "ST3" },
        { text: "st4", value: "ST4" },
        { text: "st5", value: "ST5" },
        { text: "st6", value: "ST6" },
      ],
      selectedFilterTags: [],
    };
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (this.noMoreOrders) return;

      if (scrollTop + clientHeight >= scrollHeight) {
        this.loadMoreOrders();
      }
    },
    async loadMoreOrders() {
      if (!this.paginatingOrders) {
        this.paginatingOrders = true;
        let results = await this.$store.dispatch("getOrdersGraph", {
          numOrders: 20,
          cursor: this.cursor,
        });

        function sleep(ms) {
          return new Promise((resolve) => setTimeout(resolve, ms));
        }
        await sleep(1500);

        this.paginatingOrders = false;
      }
    },
    selectOrder(order) {
      this.selectedOrder = order;
      this.$emit("orderChanged", order);
    },
    async orderSearch(event) {
      this.loadingOrders = true;
      this.paginatingOrders = false;
      let queries = [];
      if (this.selectedFilterTags) {
        for (let tag of this.selectedFilterTags) {
          queries.push(`tag:'${tag}'`);
        }
      }
      if (this.customerId) {
        let property = this.customerId.includes("@") ? "email" : "name";
        queries.push(`${property}:'${this.customerId}'`);
      }

      await this.$store.dispatch("getOrdersGraph", {
        numOrders: 20,
        query: queries.join(" AND "),
      });

      this.loadingOrders = false;
    },
  },
  async mounted() {
    await this.$store.dispatch("getOrdersGraph", {
      numOrders: 20,
    });
    this.order = this.orders[0];
    this.loadingOrders = false;
  },
  created() {
    bus.$on("orderFinished", async (orderId) => {
      await this.$store.dispatch("removeOrder", orderId);
      let nextOrder = this.orders[0] || {};
      this.selectOrder(nextOrder);
    });

    bus.$on("orderCancelled", async (orderId) => {
      this.selectOrder({});
    });
  },
  computed: {
    orders() {
      if (!this.$store.state.orders) {
        return [];
      }
      return this.$store.state.orders;
    },
    cursor() {
      return this.$store.state.cursor;
    },
    noMoreOrders() {
      return this.$store.state.noMoreOrders;
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu {
  width: 220px;
}

.search-button {
  border: 1px solid #ced4da !important;
}

.order-list {
  .btn {
    &:focus {
      outline: none;
      -webkit-appearance: none !important;
      box-shadow: none;
    }
  }
}

#orders {
  height: 82vh;
  overflow-y: scroll;
  overflow-x: none;
  border: 1px solid rgba(0, 0, 0, 0.125);

  .order-row {
    text-align: left;
  }

  &::-webkit-scrollbar {
    // display: none;
  }

  .list-group-item {
    flex-basis: 90px;
    flex-shrink: 0;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  }

  .active {
    background-color: #e9ecef !important;
    border-radius: 0;
    color: #2c3e50;
  }
}

.orders-search {
  display: inline-flex;
  width: 100%;
}
</style>
